import * as React from 'react';
import { getLogger } from '@packages/core/logging';
import { VinSessionContext, VinSessionDispatchContext } from './vin-sessions.context';
import { VinSessionActionDispatcher, vinSessionActions } from './vin-sessions.state';
import { VinSessionService } from './vin-session.service';
import { VIN } from '../types';

const logger = getLogger('vin-sessions');

export const useVinSessionState = () => {
    const vinSessionState = React.useContext(VinSessionContext);

    if (vinSessionState === undefined) {
        throw new Error('VinSessionContext must be used within an VinSessionProvider');
    }

    return vinSessionState;
};

export const useVinSessionDispatch = () => {
    const vinSessionDispatch = React.useContext(VinSessionDispatchContext);

    if (vinSessionDispatch === undefined) {
        throw new Error('VinSessionDispatchContext must be used within an VinSessionProvider');
    }

    return vinSessionDispatch;
};

export async function fetchPublicationsCount(
    dispatch: VinSessionActionDispatcher,
    vinSessionService: VinSessionService,
    vin: VIN
) {
    if (!vin) {
        return;
    }

    try {
        const response = await vinSessionService.getPublications({
            vin: vin.vinRecord.vin,
            body: {
                carlineId: vin?.carlineId,
                searchType: 'all',
                modelYear: vin?.vinRecord.modelYear,
                docStatus: 'published',
            },
            uri: '?page=0&size=10',
            ignoreCache: true,
        });
        if (response.success) {
            dispatch(vinSessionActions.setPublicationsCount({ publicationsCount: response.data.page.totalElements }));
            dispatch(vinSessionActions.setHasPublicationsCountFetched());
        }
    } catch (e) {
        logger.error(`Failed to fetch the publications count [${vin.vinRecord.vin}]`, {
            error: e,
            vin: vin.vinRecord.vin,
        });
    }
}

export async function fetchQmrsCount(
    dispatch: VinSessionActionDispatcher,
    vinSessionService: VinSessionService,
    vin: string
) {
    if (!vin) {
        return;
    }

    try {
        const response = await vinSessionService.getQaSideNavCount({
            vin: vin,
            ignoreCache: true,
        });

        if (response.success) {
            dispatch(vinSessionActions.setVinQmrsCount({ vinQmrsCount: response.data }));
            dispatch(vinSessionActions.setHasQmrsCountFetched());
        }
    } catch (e) {
        logger.error(`Failed to fetch the QMRs count [${vin}]`, { error: e, vin });
    }
}
